module.exports = __webpack_public_path__ + "static/media/cartagena-18.84f49ef9.jpg";